import React, { useState } from 'react'

export default function PreviewImage({ file }) {

    const [preview, setPreview] = useState(null);
    if (file) {
        try {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setPreview(reader.result);
            }
        }
        catch (error) {

        }
    }
    else {
        console.log()
    }

    return (
        <div>
            {(file && preview) ?
                <img src={preview} width={150} height={80} alt='' /> :
                null}
        </div>
    )
}
